import { useEffect, useState } from 'react';

export type FigmaBreakpoint = '1920' | '1440' | '768' | '375';

function getBreakpoint(width: number): FigmaBreakpoint {
  if (width >= 1600) return '1920';
  if (width >= 1024) return '1440';
  if (width >= 480) return '768';
  return '375';
}

export function useFigmaBreakpoint(): FigmaBreakpoint {
  const [breakpoint, setBreakpoint] = useState<FigmaBreakpoint>(() =>
    typeof window === 'undefined' ? '1440' : getBreakpoint(window.innerWidth),
  );

  useEffect(() => {
    const update = () => setBreakpoint(getBreakpoint(window.innerWidth));
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return breakpoint;
}
